import ErrorScreen from './error_screen'
export default ErrorScreen
